export interface TestComponent {
  component: {}
  componentWithProviders: JSX.Element
}

export enum CallResult {
  'Initial',
  'Running',
  'Failed',
  'Succeeded'
}

export interface BaseAction {
  type: string
}

export interface EmptyAction extends BaseAction {}

export interface MessageAction extends BaseAction{
  message: string
}

export interface DataAction<T> extends BaseAction {
  data: T
}
